import { HANDLE_RAZOR_PAY_API } from "../APIs/index"
import { CONFIRMBOOKING } from "../constants/RoutingPath";

const razorPayPaymentKey = process.env.REACT_APP_PAYMENT_KEY

const loadScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};

export const displayRazorpay = async (payload, setData) => {
    // Load Razorpay SDK
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');

    if (!res) {
        alert('Razorpay SDK failed to load. Are you online?');
        return;
    }
    let order;
    const response = await HANDLE_RAZOR_PAY_API(payload)
    if (response && response?.status) {
        order = response?.data
    }
    const options = {
        key: razorPayPaymentKey,
        amount: order.amount,
        currency: order?.currency,
        name: 'TRPEVENT',
        description: 'TOPUP',
        image: 'https://cdn.razorpay.com/logos/Lj7wVt9C8Bs6AB_medium.png',
        order_id: order?.id,
        handler: function (response) {
            setData(response)
        },
        prefill: {
            name: `${order?.first_name} ${order?.last_name}`,
            email: `${order?.email}`,
            contact: `${order?.mobile_number}`,
        },
        notes: {
            address: order?.address,
        },
        theme: {
            color: '#3399cc',
        },
        check: {
            card: true,
            netbanking: true,
            wallet: true,
            upi: false,
        },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
};
